import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import {catchError, concatMap, map, switchMap, withLatestFrom} from 'rxjs/operators';
import {EMPTY, of} from 'rxjs';
import { DeviceMonitoringActionTypes, DeviceMonitoringActions } from '../actions/device-monitoring.actions';
import * as fromStore from '../../../store';
import * as featureActions from '../../index';
import {Store} from '@ngrx/store';
import {DeviceMgtService} from '../../../services/device-mgt.service';
import {DeviceSubType} from '../../../shareModel';

@Injectable()
export class DeviceMonitoringEffects {
  private actions$ = inject(Actions);
  private store$ = inject(Store<fromStore.State>);
  private deveicesMgtService = inject(DeviceMgtService);

  constructor() {}

  getDeviceMonitorings$ = createEffect(() => this.actions$.pipe(
    ofType(DeviceMonitoringActionTypes.GetDeviceMonitorings),
    map((action: featureActions.GetDeviceMonitorings) => action.payload),
    withLatestFrom(this.store$.select(fromStore.getDeviceMonitoringState)),
    switchMap(([payload, dataExisted]) => {
      if (!payload.dcode) { // skip fetching all data.
        return of(payload);
      }
      const dcode = payload.dcode;
      if (dataExisted.entities.hasOwnProperty(dcode)) {
        return of(null);
      }
      return of(payload);
    }),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([payload, user]) => {
      if (payload === null) {
        return of(new featureActions.NoDeviceMonitoringsChanged());
      }
      // if (payload.device_status === undefined || payload.device_status.length === 0) {  // status 為空時, 不繼續往下呼叫 API, 但頁面端要配合判斷清空 list 才行
      //   return of(new featureActions.NoDeviceMonitoringsChanged());
      // }
      // 創建新對象副本以避免修改只讀的 action payload (NgRx 9 immutability)
      let params = { ...payload, otp: user.otp };
      if (params.regionId < 0) {
        const { regionId, ...paramsWithoutRegion } = params;
        params = paramsWithoutRegion;
      }
      return this.deveicesMgtService.ReadDeviceAdminStatus(params).pipe(
        switchMap((res) => {
          if (res.result && Array.isArray(res.msg.device_status)) {
            const dcodeList = res.msg.device_status.map((i) => i.dcode);
            return [new featureActions.UpsertDeviceMonitorings({deviceMonitorings: res.msg.device_status}),
              new featureActions.GetDevices(dcodeList)];
          } else {
            return [new featureActions.NoDeviceMonitoringsChanged()];
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError(error => {
          return of(new featureActions.GetDeviceMonitoringFail());
        })
      );
    })
  ));

  // @Effect()
  // getDeviceMonitorings$ = this.actions$.pipe(
  //   ofType(DeviceMonitoringActionTypes.GetDeviceMonitorings),
  //   withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
  //   switchMap(([action, user]) => {
  //     const params = action.payload;
  //     params.otp = user.otp;
  //     if (params.regionId < 0) {
  //       delete params.regionId;
  //     }
  //     return this.deveicesMgtService.ReadDeviceAdminStatus(params).pipe(
  //       switchMap((res) => {
  //         if (res.result && Array.isArray(res.msg.device_status)) {
  //           const dcodeList = res.msg.device_status.map((i) => i.dcode);
  //           return [new featureActions.UpsertDeviceMonitorings({deviceMonitorings: res.msg.device_status}),
  //             new featureActions.GetDevices(dcodeList)];
  //         } else {
  //           return [new featureActions.LoadDeviceMonitorings({deviceMonitorings: []})];
  //         }
  //       }), catchError(error => {
  //         return of(new featureActions.GetDeviceMonitoringFail());
  //       })
  //     );
  //   })
  // );



}
